<template>
  <v-dialog scrollable v-model="show" width="960px">
    <v-card style="height: 600px">
      <v-card-title>{{ title }}</v-card-title>
      <v-container fluid>
        <v-layout row>
          <v-flex xs3>
            <v-layout column>
              <v-flex>
                <v-checkbox
                  :label="$t('app.labels.canSelect')"
                  v-model="srcAll"
                ></v-checkbox>
              </v-flex>
              <v-flex class="fields">
                <v-layout :key="index" row v-for="(field, index) in srcFields">
                  <v-checkbox
                    :label="field.text"
                    :value="index"
                    v-model="srcSelected"
                  ></v-checkbox>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs1>
            <v-layout align-center column justify-center style="height: 100%">
              <v-btn @click="moveIn" icon>
                <v-icon>arrow_forward</v-icon>
              </v-btn>
              <v-btn @click="moveOut" icon>
                <v-icon>arrow_back</v-icon>
              </v-btn>
            </v-layout>
          </v-flex>
          <v-flex xs7>
            <v-layout column>
              <v-flex>
                <v-checkbox
                  :label="$t('app.labels.selected')"
                  v-model="disAll"
                ></v-checkbox>
              </v-flex>
              <v-flex class="fields">
                <v-layout :key="index" row v-for="(field, index) in dispFields">
                  <v-flex grow>
                    <v-checkbox
                      :label="field.text"
                      :value="index"
                      v-model="dispSelected"
                    />
                  </v-flex>
                  <v-flex shrink>
                    <v-radio-group row v-model="field.sort">
                      <v-radio
                        v-if="!tdoc"
                        :label="$t('app.labels.sort.none')"
                        value
                      ></v-radio>
                      <v-radio
                        :label="$t('app.labels.sort.asc')"
                        value="asc"
                      ></v-radio>
                      <v-radio
                        :label="$t('app.labels.sort.desc')"
                        value="desc"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex v-if="!tdoc" xs1>
            <v-layout align-center column justify-center style="height: 100%">
              <v-btn
                :disabled="dispSelected.length !== 1 || dispSelected[0] === 0"
                @click="moveTop"
                icon
              >
                <v-icon>vertical_align_top</v-icon>
              </v-btn>
              <v-btn
                :disabled="dispSelected.length !== 1 || dispSelected[0] === 0"
                @click="moveUp"
                icon
              >
                <v-icon>arrow_upward</v-icon>
              </v-btn>
              <v-btn
                :disabled="
                  dispSelected.length !== 1 ||
                    dispSelected[0] === dispFields.length - 1
                "
                @click="moveDown"
                class="move move-to-down"
                icon
              >
                <v-icon>arrow_downward</v-icon>
              </v-btn>
              <v-btn
                :disabled="
                  dispSelected.length !== 1 ||
                    dispSelected[0] === dispFields.length - 1
                "
                @click="moveBottom"
                class="move move-to-up"
                icon
              >
                <v-icon>vertical_align_bottom</v-icon>
              </v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-btn @click="save">{{ $t('app.buttons.save') }}</v-btn>
        <v-btn @click="show = false">{{ $t('app.buttons.back') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['tdoc'],
  data() {
    return {
      show: false,
      title: null,
      fields: [],
      srcSelected: [],
      srcAll: false,
      dispSelected: [],
      disAll: false,
      resolve: null,
      reject: null,
    }
  },
  computed: {
    srcFields() {
      return this.fields.filter((f) => !f.seq)
    },
    dispFields() {
      return this.fields.filter((f) => f.seq).sort((a, b) => a.seq - b.seq)
    },
  },
  methods: {
    popupByEmployeeId(title, fields, id) {
      this.title = title
      this.show = true
      this.$http.get(`/tdoc/bls/${id}/sort`).then((res) => {
        let savedList = res.data || []

        savedList.forEach((s) => {
          let field = fields.find((f) => f.value === s.fieldName)
          field.sort = s.sortMethod
          field.seq = s.seq
        })

        this.fields = fields
      })
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    popup(title, fields) {
      this.title = title
      let savedList = JSON.parse(localStorage.getItem(title)) || []

      this.fields = fields.map((f) => {
        let saved = savedList.find(
          (s) => s.text === f.text && s.value === f.value
        )
        return saved || f
      })
      this.show = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    moveIn() {
      this.srcSelected.forEach((s, i) => {
        this.srcFields[s].seq = new Date().getTime() + i
      })
      this.fields = [...this.fields]
      this.srcSelected = []
      this.srcAll = false
      this.disAll = false
    },
    moveOut() {
      this.dispSelected.forEach((s) => {
        delete this.dispFields[s].sort
        delete this.dispFields[s].seq
      })
      this.fields = [...this.fields]
      this.dispSelected = []
      this.srcAll = false
      this.disAll = false
    },
    moveUp() {
      let from = this.dispFields[this.dispSelected[0]]
      let to = this.dispFields[this.dispSelected[0] - 1]
      let temp = from.seq
      from.seq = to.seq
      to.seq = temp
      this.fields = [...this.fields]
      this.dispSelected = [this.dispSelected[0] - 1]
    },
    moveDown() {
      let from = this.dispFields[this.dispSelected[0]]
      let to = this.dispFields[this.dispSelected[0] + 1]
      let temp = from.seq
      from.seq = to.seq
      to.seq = temp
      this.fields = [...this.fields]
      this.dispSelected = [this.dispSelected[0] + 1]
    },
    moveTop() {
      let from = this.dispSelected[0]
      this.dispFields[from].seq = this.dispFields[0].seq - 1
      this.fields = [...this.fields]
      this.dispSelected = [0]
    },
    moveBottom() {
      let from = this.dispSelected[0]
      this.dispFields[from].seq =
        this.dispFields[this.dispFields.length - 1].seq + 1
      this.fields = [...this.fields]
      this.dispSelected = [this.dispFields.length - 1]
    },
    save() {
      this.show = false
      this.resolve(this.dispFields)
      if (!this.tdoc) {
        localStorage.setItem(this.title, JSON.stringify(this.fields))
      }
      this.srcSelected = []
      this.dispSelected = []
    },
  },
  watch: {
    srcAll: function() {
      if (this.srcAll) {
        this.srcFields.forEach((f, i) => {
          this.$set(this.srcSelected, i, i)
        })
      } else {
        this.srcSelected = []
      }
    },
    disAll: function() {
      if (this.disAll) {
        this.dispFields.forEach((f, i) => {
          this.$set(this.dispSelected, i, i)
        })
      } else {
        this.dispSelected = []
      }
    },
  },
}
</script>

<style scoped>
.fields {
  padding: 5px;
  width: 100%;
  height: 400px;
  border: 1px solid #ccc;
  overflow-y: auto;
  margin: 0px;
  border-radius: 4px;
}

.fields::-webkit-scrollbar {
  width: 8px;
  background: transparent;
}

.fields::-webkit-scrollbar-thumb {
  width: 8px;
  background: rgba(66, 66, 66, 0.6);
  border-radius: 4px;
}

.flex .v-input--selection-controls {
  margin-top: 2px;
  padding-top: 4px;
}
</style>
